const COUNTRY_CAPITALS = {
  AD: { capital: "Andorra la Vella", name: "Andorra", alpha3: 'AND', numeric: '020' },
  AE: { capital: "Abu Dhabi", name: "United Arab Emirates", alpha3: 'ARE', numeric: '784' },
  AF: { capital: "Kabul", name: "Afghanistan", alpha3: 'AFG', numeric: '004' },
  AG: { capital: "Saint John's", name: "Antigua and Barbuda", alpha3: 'ATG', numeric: '028' },
  AI: { capital: "The Valley", name: "Anguilla", alpha3: 'AIA', numeric: '660' },
  AL: { capital: "Tirana", name: "Albania", alpha3: 'ALB', numeric: '008' },
  AM: { capital: "Yerevan", name: "Armenia", alpha3: 'ARM', numeric: '051' },
  AO: { capital: "Luanda", name: "Angola", alpha3: 'AGO', numeric: '024' },
  AQ: {
    capital: "McMurdo Station",
    name: "Antarctica",
    alpha3: 'ATA',
    numeric: '010',
    altNames: ["Antarctica"],
  },
  AR: { capital: "Buenos Aires", name: "Argentina", alpha3: 'ARG', numeric: '032' },
  AS: { capital: "Pago Pago", name: "American Samoa", alpha3: 'ASM', numeric: '016' },
  AT: { capital: "Vienna", name: "Austria", alpha3: 'AUT', numeric: '040' },
  AU: { capital: "Canberra", name: "Australia", alpha3: 'AUS', numeric: '036' },
  AW: { capital: "Oranjestad", name: "Aruba", alpha3: 'ABW', numeric: '533' },
  AX: { capital: "Mariehamn", name: "Aland Islands", alpha3: 'ALA', numeric: '248' },
  AZ: { capital: "Baku", name: "Azerbaijan", alpha3: 'AZE', numeric: '031' },
  BA: { capital: "Sarajevo", name: "Bosnia and Herzegovina", alpha3: 'BIH', numeric: '070' },
  BB: { capital: "Bridgetown", name: "Barbados", alpha3: 'BRB', numeric: '052' },
  BD: { capital: "Dhaka", name: "Bangladesh", alpha3: 'BGD', numeric: '050' },
  BE: { capital: "Brussels", name: "Belgium", alpha3: 'BEL', numeric: '056' },
  BF: { capital: "Ouagadougou", name: "Burkina Faso", alpha3: 'BFA', numeric: '854' },
  BG: { capital: "Sofia", name: "Bulgaria", alpha3: 'BGR', numeric: '100' },
  BH: { capital: "Manama", name: "Bahrain", alpha3: 'BHR', numeric: '048' },
  BI: { capital: "Gitega", name: "Burundi", alpha3: 'BDI', numeric: '108' },
  BJ: { capital: "Porto-Novo", name: "Benin", alpha3: 'BEN', numeric: '204' },
  BL: { capital: "Gustavia", name: "Saint Barthelemy", alpha3: 'BLM', numeric: '652' },
  BM: { capital: "Hamilton", name: "Bermuda", alpha3: 'BMU', numeric: '060' },
  BN: { capital: "Bandar Seri Begawan", name: "Brunei", alpha3: 'BRN', numeric: '096' },
  BO: { capital: "Sucre", name: "Bolivia", alpha3: 'BOL', numeric: '068' },
  BQ: { capital: "Kralendijk", name: "Caribbean Netherlands", alpha3: 'BES', numeric: '535' },
  BR: { capital: "Brasilia", name: "Brazil", alpha3: 'BRA', numeric: '076' },
  BS: { capital: "Nassau", name: "Bahamas", alpha3: 'BHS', numeric: '044' },
  BT: { capital: "Thimphu", name: "Bhutan", alpha3: 'BTN', numeric: '064' },
  BV: {
    capital: "Bouvet Island",
    name: "Bouvet Island",
    alpha3: 'BVT',
    numeric: '074',
  },
  BW: { capital: "Gaborone", name: "Botswana", alpha3: 'BWA', numeric: '072' },
  BY: { capital: "Minsk", name: "Belarus", alpha3: 'BLR', numeric: '112' },
  BZ: { capital: "Belmopan", name: "Belize", alpha3: 'BLZ', numeric: '084' },
  CA: { capital: "Ottawa", name: "Canada", alpha3: 'CAN', numeric: '124' },
  CC: { capital: "West Island", name: "Cocos (Keeling) Islands", alpha3: 'CCK', numeric: '166' },
  CD: { capital: "Kinshasa", name: "DR Congo", alpha3: 'COD', numeric: '180' },
  CF: { capital: "Bangui", name: "Central African Republic", alpha3: 'CAF', numeric: '140' },
  CG: { capital: "Brazzaville", name: "Republic of the Congo", alpha3: 'COG', numeric: '178' },
  CH: { capital: "Bern", name: "Switzerland", alpha3: 'CHE', numeric: '756' },
  CI: { capital: "Yamoussoukro", name: "Ivory Coast", alpha3: 'CIV', numeric: '384' },
  CK: { capital: "Avarua", name: "Cook Islands", alpha3: 'COK', numeric: '184' },
  CL: { capital: "Santiago", name: "Chile", alpha3: 'CHL', numeric: '152' },
  CM: { capital: "Yaounde", name: "Cameroon", alpha3: 'CMR', numeric: '120' },
  CN: { capital: "Beijing", name: "China", alpha3: 'CHN', numeric: '156' },
  CO: { capital: "Bogota", name: "Colombia", alpha3: 'COL', numeric: '170' },
  CR: { capital: "San Jose", name: "Costa Rica", alpha3: 'CRI', numeric: '188' },
  CU: { capital: "Havana", name: "Cuba", alpha3: 'CUB', numeric: '192' },
  CV: { capital: "Praia", name: "Cape Verde", alpha3: 'CPV', numeric: '132' },
  CW: { capital: "Willemstad", name: "Curacao", alpha3: 'CUW', numeric: '531' },
  CX: { capital: "Flying Fish Cove", name: "Christmas Island", alpha3: 'CXR', numeric: '162' },
  CY: { capital: "Nicosia", name: "Cyprus", alpha3: 'CYP', numeric: '196' },
  CZ: { capital: "Prague", name: "Czechia", alpha3: 'CZE', numeric: '203' },
  DE: { capital: "Berlin", name: "Germany", alpha3: 'DEU', numeric: '276' },
  DJ: { capital: "Djibouti", name: "Djibouti", alpha3: 'DJI', numeric: '262' },
  DK: { capital: "Copenhagen", name: "Denmark", alpha3: 'DNK', numeric: '208' },
  DM: { capital: "Roseau", name: "Dominica", alpha3: 'DMA', numeric: '212' },
  DO: { capital: "Santo Domingo", name: "Dominican Republic", alpha3: 'DOM', numeric: '214' },
  DZ: { capital: "Algiers", name: "Algeria", alpha3: 'DZA', numeric: '012' },
  EC: { capital: "Quito", name: "Ecuador", alpha3: 'ECU', numeric: '218' },
  EE: { capital: "Tallinn", name: "Estonia", alpha3: 'EST', numeric: '233' },
  EG: { capital: "Cairo", name: "Egypt", alpha3: 'EGY', numeric: '818' },
  EH: { capital: "El Aaiun", name: "Western Sahara", alpha3: 'ESH', numeric: '732' },
  ER: { capital: "Asmara", name: "Eritrea", alpha3: 'ERI', numeric: '232' },
  ES: { capital: "Madrid", name: "Spain", alpha3: 'ESP', numeric: '724' },
  ET: { capital: "Addis Ababa", name: "Ethiopia", alpha3: 'ETH', numeric: '231' },
  FI: { capital: "Helsinki", name: "Finland", alpha3: 'FIN', numeric: '246' },
  FJ: { capital: "Suva", name: "Fiji", alpha3: 'FJI', numeric: '242' },
  FK: { capital: "Stanley", name: "Falkland Islands", alpha3: 'FLK', numeric: '238' },
  FM: { capital: "Palikir", name: "Micronesia", alpha3: 'FSM', numeric: '583' },
  FO: { capital: "Torshavn", name: "Faroe Islands", alpha3: 'FRO', numeric: '234' },
  FR: { capital: "Paris", name: "France", alpha3: 'FRA', numeric: '250' },
  GA: { capital: "Libreville", name: "Gabon", alpha3: 'GAB', numeric: '266' },
  GB: { capital: "London", name: "United Kingdom", alpha3: 'GBR', numeric: '826' },
  GD: { capital: "St. George's", name: "Grenada", alpha3: 'GRD', numeric: '308' },
  GE: { capital: "Tbilisi", name: "Georgia", alpha3: 'GEO', numeric: '268' },
  GF: { capital: "Cayenne", name: "French Guiana", alpha3: 'GUF', numeric: '254' },
  GG: { capital: "St. Peter Port", name: "Guernsey", alpha3: 'GGY', numeric: '831' },
  GH: { capital: "Accra", name: "Ghana", alpha3: 'GHA', numeric: '288' },
  GI: { capital: "Gibraltar", name: "Gibraltar", alpha3: 'GIB', numeric: '292' },
  GL: { capital: "Nuuk", name: "Greenland", alpha3: 'GRL', numeric: '304' },
  GM: { capital: "Banjul", name: "Gambia", alpha3: 'GMB', numeric: '270' },
  GN: { capital: "Conakry", name: "Guinea", alpha3: 'GIN', numeric: '324' },
  GP: { capital: "Basse-Terre", name: "Guadeloupe", alpha3: 'GLP', numeric: '312' },
  GQ: { capital: "Malabo", name: "Equatorial Guinea", alpha3: 'GNQ', numeric: '226' },
  GR: { capital: "Athens", name: "Greece", alpha3: 'GRC', numeric: '300' },
  GS: { capital: "King Edward Point", name: "South Georgia", alpha3: 'SGS', numeric: '239' },
  GT: { capital: "Guatemala City", name: "Guatemala", alpha3: 'GTM', numeric: '320' },
  GU: { capital: "Hagatna", name: "Guam", alpha3: 'GUM', numeric: '316' },
  GW: { capital: "Bissau", name: "Guinea-Bissau", alpha3: 'GNB', numeric: '624' },
  GY: { capital: "Georgetown", name: "Guyana", alpha3: 'GUY', numeric: '328' },
  HK: { capital: "City of Victoria", name: "Hong Kong", alpha3: 'HKG', numeric: '344' },
  HM: {
    capital: "Heard Island",
    name: "Heard Island and McDonald Islands",
    alpha3: 'HMD',
    numeric: '334',
    altNames: ["Heard Island", "Atlas Cove"],
  },
  HN: { capital: "Tegucigalpa", name: "Honduras", alpha3: 'HND', numeric: '340' },
  HR: { capital: "Zagreb", name: "Croatia", alpha3: 'HRV', numeric: '191' },
  HT: { capital: "Port-au-Prince", name: "Haiti", alpha3: 'HTI', numeric: '332' },
  HU: { capital: "Budapest", name: "Hungary", alpha3: 'HUN', numeric: '348' },
  ID: { capital: "Jakarta", name: "Indonesia", alpha3: 'IDN', numeric: '360' },
  IE: { capital: "Dublin", name: "Ireland", alpha3: 'IRL', numeric: '372' },
  IL: { capital: "Jerusalem", name: "Israel", alpha3: 'ISR', numeric: '376' },
  IM: { capital: "Douglas", name: "Isle of Man", alpha3: 'IMN', numeric: '833' },
  IN: { capital: "New Delhi", name: "India", alpha3: 'IND', numeric: '356' },
  IO: { capital: "Diego Garcia", name: "British Indian Ocean Territory", alpha3: 'IOT', numeric: '086' },
  IQ: { capital: "Baghdad", name: "Iraq", alpha3: 'IRQ', numeric: '368' },
  IR: { capital: "Tehran", name: "Iran", alpha3: 'IRN', numeric: '364' },
  IS: { capital: "Reykjavik", name: "Iceland", alpha3: 'ISL', numeric: '352' },
  IT: { capital: "Rome", name: "Italy", alpha3: 'ITA', numeric: '380' },
  JE: { capital: "Saint Helier", name: "Jersey", alpha3: 'JEY', numeric: '832' },
  JM: { capital: "Kingston", name: "Jamaica", alpha3: 'JAM', numeric: '388' },
  JO: { capital: "Amman", name: "Jordan", alpha3: 'JOR', numeric: '400' },
  JP: { capital: "Tokyo", name: "Japan", alpha3: 'JPN', numeric: '392' },
  KE: { capital: "Nairobi", name: "Kenya", alpha3: 'KEN', numeric: '404' },
  KG: { capital: "Bishkek", name: "Kyrgyzstan", alpha3: 'KGZ', numeric: '417' },
  KH: { capital: "Phnom Penh", name: "Cambodia", alpha3: 'KHM', numeric: '116' },
  KI: { capital: "South Tarawa", name: "Kiribati", alpha3: 'KIR', numeric: '296' },
  KM: { capital: "Moroni", name: "Comoros", alpha3: 'COM', numeric: '174' },
  KN: { capital: "Basseterre", name: "Saint Kitts and Nevis", alpha3: 'KNA', numeric: '659' },
  KP: { capital: "Pyongyang", name: "North Korea", alpha3: 'PRK', numeric: '408' },
  KR: { capital: "Seoul", name: "South Korea", alpha3: 'KOR', numeric: '410' },
  KW: { capital: "Kuwait City", name: "Kuwait", alpha3: 'KWT', numeric: '414' },
  KY: { capital: "George Town", name: "Cayman Islands", alpha3: 'CYM', numeric: '136' },
  KZ: { capital: "Astana", name: "Kazakhstan", alpha3: 'KAZ', numeric: '398' },
  LA: { capital: "Vientiane", name: "Laos", alpha3: 'LAO', numeric: '418' },
  LB: { capital: "Beirut", name: "Lebanon", alpha3: 'LBN', numeric: '422' },
  LC: { capital: "Castries", name: "Saint Lucia", alpha3: 'LCA', numeric: '662' },
  LI: { capital: "Vaduz", name: "Liechtenstein", alpha3: 'LIE', numeric: '438' },
  LK: { capital: "Sri Jayawardenepura Kotte", name: "Sri Lanka", alpha3: 'LKA', numeric: '144' },
  LR: { capital: "Monrovia", name: "Liberia", alpha3: 'LBR', numeric: '430' },
  LS: { capital: "Maseru", name: "Lesotho", alpha3: 'LSO', numeric: '426' },
  LT: { capital: "Vilnius", name: "Lithuania", alpha3: 'LTU', numeric: '440' },
  LU: { capital: "Luxembourg", name: "Luxembourg", alpha3: 'LUX', numeric: '442' },
  LV: { capital: "Riga", name: "Latvia", alpha3: 'LVA', numeric: '428' },
  LY: { capital: "Tripoli", name: "Libya", alpha3: 'LBY', numeric: '434' },
  MA: { capital: "Rabat", name: "Morocco", alpha3: 'MAR', numeric: '504' },
  MC: { capital: "Monaco", name: "Monaco", alpha3: 'MCO', numeric: '492' },
  MD: { capital: "Chisinau", name: "Moldova", alpha3: 'MDA', numeric: '498' },
  ME: { capital: "Podgorica", name: "Montenegro", alpha3: 'MNE', numeric: '499' },
  MF: { capital: "Marigot", name: "Saint Martin", alpha3: 'MAF', numeric: '663' },
  MG: { capital: "Antananarivo", name: "Madagascar", alpha3: 'MDG', numeric: '450' },
  MH: { capital: "Majuro", name: "Marshall Islands", alpha3: 'MHL', numeric: '584' },
  MK: { capital: "Skopje", name: "North Macedonia", alpha3: 'MKD', numeric: '807' },
  ML: { capital: "Bamako", name: "Mali", alpha3: 'MLI', numeric: '466' },
  MM: { capital: "Naypyidaw", name: "Myanmar", alpha3: 'MMR', numeric: '104' },
  MN: { capital: "Ulan Bator", name: "Mongolia", alpha3: 'MNG', numeric: '496' },
  MO: {
    capital: "Macau",
    name: "Macau",
    alpha3: 'MAC',
    numeric: '446',
    altNames: ["Macao"],
  },
  MP: { capital: "Saipan", name: "Northern Mariana Islands", alpha3: 'MNP', numeric: '580' },
  MQ: { capital: "Fort-de-France", name: "Martinique", alpha3: 'MTQ', numeric: '474' },
  MR: { capital: "Nouakchott", name: "Mauritania", alpha3: 'MRT', numeric: '478' },
  MS: { capital: "Plymouth", name: "Montserrat", alpha3: 'MSR', numeric: '500' },
  MT: { capital: "Valletta", name: "Malta", alpha3: 'MLT', numeric: '470' },
  MU: { capital: "Port Louis", name: "Mauritius", alpha3: 'MUS', numeric: '480' },
  MV: { capital: "Male", name: "Maldives", alpha3: 'MDV', numeric: '462' },
  MW: { capital: "Lilongwe", name: "Malawi", alpha3: 'MWI', numeric: '454' },
  MX: { capital: "Mexico City", name: "Mexico", alpha3: 'MEX', numeric: '484' },
  MY: { capital: "Kuala Lumpur", name: "Malaysia", alpha3: 'MYS', numeric: '458' },
  MZ: { capital: "Maputo", name: "Mozambique", alpha3: 'MOZ', numeric: '508' },
  NA: { capital: "Windhoek", name: "Namibia", alpha3: 'NAM', numeric: '516' },
  NC: { capital: "Noumea", name: "New Caledonia", alpha3: 'NCL', numeric: '540' },
  NE: { capital: "Niamey", name: "Niger", alpha3: 'NER', numeric: '562' },
  NF: { capital: "Kingston", name: "Norfolk Island", alpha3: 'NFK', numeric: '574' },
  NG: { capital: "Abuja", name: "Nigeria", alpha3: 'NGA', numeric: '566' },
  NI: { capital: "Managua", name: "Nicaragua", alpha3: 'NIC', numeric: '558' },
  NL: { capital: "Amsterdam", name: "Netherlands", alpha3: 'NLD', numeric: '528' },
  NO: { capital: "Oslo", name: "Norway", alpha3: 'NOR', numeric: '578' },
  NP: { capital: "Kathmandu", name: "Nepal", alpha3: 'NPL', numeric: '524' },
  NR: { capital: "Yaren", name: "Nauru", alpha3: 'NRU', numeric: '520' },
  NU: { capital: "Alofi", name: "Niue", alpha3: 'NIU', numeric: '570' },
  NZ: { capital: "Wellington", name: "New Zealand", alpha3: 'NZL', numeric: '554' },
  OM: { capital: "Muscat", name: "Oman", alpha3: 'OMN', numeric: '512' },
  PA: { capital: "Panama City", name: "Panama", alpha3: 'PAN', numeric: '591' },
  PE: { capital: "Lima", name: "Peru", alpha3: 'PER', numeric: '604' },
  PF: { capital: "Papeete", name: "French Polynesia", alpha3: 'PYF', numeric: '258' },
  PG: { capital: "Port Moresby", name: "Papua New Guinea", alpha3: 'PNG', numeric: '598' },
  PH: { capital: "Manila", name: "Philippines", alpha3: 'PHL', numeric: '608' },
  PK: { capital: "Islamabad", name: "Pakistan", alpha3: 'PAK', numeric: '586' },
  PL: { capital: "Warsaw", name: "Poland", alpha3: 'POL', numeric: '616' },
  PM: { capital: "Saint-Pierre", name: "Saint Pierre and Miquelon", alpha3: 'SPM', numeric: '666' },
  PN: { capital: "Adamstown", name: "Pitcairn Islands", alpha3: 'PCN', numeric: '612' },
  PR: { capital: "San Juan", name: "Puerto Rico", alpha3: 'PRI', numeric: '630' },
  PS: { capital: "Ramallah", name: "Palestine", alpha3: 'PSE', numeric: '275' },
  PT: { capital: "Lisbon", name: "Portugal", alpha3: 'PRT', numeric: '620' },
  PW: { capital: "Ngerulmud", name: "Palau", alpha3: 'PLW', numeric: '585' },
  PY: { capital: "Asuncion", name: "Paraguay", alpha3: 'PRY', numeric: '600' },
  QA: { capital: "Doha", name: "Qatar", alpha3: 'QAT', numeric: '634' },
  RE: { capital: "Saint-Denis", name: "Reunion", alpha3: 'REU', numeric: '638' },
  RO: { capital: "Bucharest", name: "Romania", alpha3: 'ROU', numeric: '642' },
  RS: { capital: "Belgrade", name: "Serbia", alpha3: 'SRB', numeric: '688' },
  RU: { capital: "Moscow", name: "Russia", alpha3: 'RUS', numeric: '643' },
  RW: { capital: "Kigali", name: "Rwanda", alpha3: 'RWA', numeric: '646' },
  SA: { capital: "Riyadh", name: "Saudi Arabia", alpha3: 'SAU', numeric: '682' },
  SB: { capital: "Honiara", name: "Solomon Islands", alpha3: 'SLB', numeric: '090' },
  SC: { capital: "Victoria", name: "Seychelles", alpha3: 'SYC', numeric: '690' },
  SD: { capital: "Khartoum", name: "Sudan", alpha3: 'SDN', numeric: '729' },
  SE: { capital: "Stockholm", name: "Sweden", alpha3: 'SWE', numeric: '752' },
  SG: { capital: "Singapore", name: "Singapore", alpha3: 'SGP', numeric: '702' },
  SH: { capital: "Jamestown", name: "Saint Helena, Ascension and Tristan da Cunha", alpha3: 'SHN', numeric: '654' },
  SI: { capital: "Ljubljana", name: "Slovenia", alpha3: 'SVN', numeric: '705' },
  SJ: { capital: "Longyearbyen", name: "Svalbard and Jan Mayen", alpha3: 'SJM', numeric: '744' },
  SK: { capital: "Bratislava", name: "Slovakia", alpha3: 'SVK', numeric: '703' },
  SL: { capital: "Freetown", name: "Sierra Leone", alpha3: 'SLE', numeric: '694' },
  SM: { capital: "City of San Marino", name: "San Marino", alpha3: 'SMR', numeric: '674' },
  SN: { capital: "Dakar", name: "Senegal", alpha3: 'SEN', numeric: '686' },
  SO: { capital: "Mogadishu", name: "Somalia", alpha3: 'SOM', numeric: '706' },
  SR: { capital: "Paramaribo", name: "Suriname", alpha3: 'SUR', numeric: '740' },
  SS: { capital: "Juba", name: "South Sudan", alpha3: 'SSD', numeric: '728' },
  ST: { capital: "Sao Tome", name: "Sao Tome and Principe", alpha3: 'STP', numeric: '678' },
  SV: { capital: "San Salvador", name: "El Salvador", alpha3: 'SLV', numeric: '222' },
  SX: { capital: "Philipsburg", name: "Sint Maarten", alpha3: 'SXM', numeric: '534' },
  SY: { capital: "Damascus", name: "Syria", alpha3: 'SYR', numeric: '760' },
  SZ: { capital: "Mbabane", name: "Eswatini", alpha3: 'SWZ', numeric: '748' },
  TC: { capital: "Cockburn Town", name: "Turks and Caicos Islands", alpha3: 'TCA', numeric: '796' },
  TD: { capital: "N'Djamena", name: "Chad", alpha3: 'TCD', numeric: '148' },
  TF: { capital: "Port-aux-Francais", name: "French Southern and Antarctic Lands", alpha3: 'ATF', numeric: '260' },
  TG: { capital: "Lome", name: "Togo", alpha3: 'TGO', numeric: '768' },
  TH: { capital: "Bangkok", name: "Thailand", alpha3: 'THA', numeric: '764' },
  TJ: { capital: "Dushanbe", name: "Tajikistan", alpha3: 'TJK', numeric: '762' },
  TK: { capital: "Fakaofo", name: "Tokelau", alpha3: 'TKL', numeric: '772' },
  TL: { capital: "Dili", name: "Timor-Leste", alpha3: 'TLS', numeric: '626' },
  TM: { capital: "Ashgabat", name: "Turkmenistan", alpha3: 'TKM', numeric: '795' },
  TN: { capital: "Tunis", name: "Tunisia", alpha3: 'TUN', numeric: '788' },
  TO: { capital: "Nuku'alofa", name: "Tonga", alpha3: 'TON', numeric: '776' },
  TR: { capital: "Ankara", name: "Turkey", alpha3: 'TUR', numeric: '792' },
  TT: { capital: "Port of Spain", name: "Trinidad and Tobago", alpha3: 'TTO', numeric: '780' },
  TV: { capital: "Funafuti", name: "Tuvalu", alpha3: 'TUV', numeric: '798' },
  TW: { capital: "Taipei", name: "Taiwan", alpha3: 'TWN', numeric: '158' },
  TZ: { capital: "Dodoma", name: "Tanzania", alpha3: 'TZA', numeric: '834' },
  UA: { capital: "Kyiv", name: "Ukraine", alpha3: 'UKR', numeric: '804' },
  UG: { capital: "Kampala", name: "Uganda", alpha3: 'UGA', numeric: '800' },
  UM: { capital: "Washington DC", name: "United States Minor Outlying Islands", alpha3: 'UMI', numeric: '581' },
  US: { capital: "Washington, D.C.", name: "United States", alpha3: 'USA', numeric: '840' },
  UY: { capital: "Montevideo", name: "Uruguay", alpha3: 'URY', numeric: '858' },
  UZ: { capital: "Tashkent", name: "Uzbekistan", alpha3: 'UZB', numeric: '860' },
  VA: { capital: "Vatican City", name: "Vatican City", alpha3: 'VAT', numeric: '336' },
  VC: { capital: "Kingstown", name: "Saint Vincent and the Grenadines", alpha3: 'VCT', numeric: '670' },
  VE: { capital: "Caracas", name: "Venezuela", alpha3: 'VEN', numeric: '862' },
  VG: { capital: "Road Town", name: "British Virgin Islands", alpha3: 'VGB', numeric: '092' },
  VI: { capital: "Charlotte Amalie", name: "United States Virgin Islands", alpha3: 'VIR', numeric: '850' },
  VN: { capital: "Hanoi", name: "Vietnam", alpha3: 'VNM', numeric: '704' },
  VU: { capital: "Port Vila", name: "Vanuatu", alpha3: 'VUT', numeric: '548' },
  WF: { capital: "Mata-Utu", name: "Wallis and Futuna", alpha3: 'WLF', numeric: '876' },
  WS: { capital: "Apia", name: "Samoa", alpha3: 'WSM', numeric: '882' },
  XK: { capital: "Pristina", name: "Kosovo", alpha3: 'UNK' },
  YE: { capital: "Sana'a", name: "Yemen", alpha3: 'YEM', numeric: '887' },
  YT: { capital: "Mamoudzou", name: "Mayotte", alpha3: 'MYT', numeric: '175' },
  ZA: { capital: "Pretoria", name: "South Africa", alpha3: 'ZAF', numeric: '710' },
  ZM: { capital: "Lusaka", name: "Zambia", alpha3: 'ZMB', numeric: '894' },
  ZW: { capital: "Harare", name: "Zimbabwe", alpha3: 'ZWE', numeric: '716' },
};

const ALPHA3_TO_ALPHA2 = {
  ABW: 'AW',
  AFG: 'AF',
  AGO: 'AO',
  AIA: 'AI',
  ALA: 'AX',
  ALB: 'AL',
  AND: 'AD',
  ARE: 'AE',
  ARG: 'AR',
  ARM: 'AM',
  ASM: 'AS',
  ATA: 'AQ',
  ATF: 'TF',
  ATG: 'AG',
  AUS: 'AU',
  AUT: 'AT',
  AZE: 'AZ',
  BDI: 'BI',
  BEL: 'BE',
  BEN: 'BJ',
  BES: 'BQ',
  BFA: 'BF',
  BGD: 'BD',
  BGR: 'BG',
  BHR: 'BH',
  BHS: 'BS',
  BIH: 'BA',
  BLM: 'BL',
  BLR: 'BY',
  BLZ: 'BZ',
  BMU: 'BM',
  BOL: 'BO',
  BRA: 'BR',
  BRB: 'BB',
  BRN: 'BN',
  BTN: 'BT',
  BVT: 'BV',
  BWA: 'BW',
  CAF: 'CF',
  CAN: 'CA',
  CCK: 'CC',
  CHE: 'CH',
  CHL: 'CL',
  CHN: 'CN',
  CIV: 'CI',
  CMR: 'CM',
  COD: 'CD',
  COG: 'CG',
  COK: 'CK',
  COL: 'CO',
  COM: 'KM',
  CPV: 'CV',
  CRI: 'CR',
  CUB: 'CU',
  CUW: 'CW',
  CXR: 'CX',
  CYM: 'KY',
  CYP: 'CY',
  CZE: 'CZ',
  DEU: 'DE',
  DJI: 'DJ',
  DMA: 'DM',
  DNK: 'DK',
  DOM: 'DO',
  DZA: 'DZ',
  ECU: 'EC',
  EGY: 'EG',
  ERI: 'ER',
  ESH: 'EH',
  ESP: 'ES',
  EST: 'EE',
  ETH: 'ET',
  FIN: 'FI',
  FJI: 'FJ',
  FLK: 'FK',
  FRA: 'FR',
  FRO: 'FO',
  FSM: 'FM',
  GAB: 'GA',
  GBR: 'GB',
  GEO: 'GE',
  GGY: 'GG',
  GHA: 'GH',
  GIB: 'GI',
  GIN: 'GN',
  GLP: 'GP',
  GMB: 'GM',
  GNB: 'GW',
  GNQ: 'GQ',
  GRC: 'GR',
  GRD: 'GD',
  GRL: 'GL',
  GTM: 'GT',
  GUF: 'GF',
  GUM: 'GU',
  GUY: 'GY',
  HKG: 'HK',
  HMD: 'HM',
  HND: 'HN',
  HRV: 'HR',
  HTI: 'HT',
  HUN: 'HU',
  IDN: 'ID',
  IMN: 'IM',
  IND: 'IN',
  IOT: 'IO',
  IRL: 'IE',
  IRN: 'IR',
  IRQ: 'IQ',
  ISL: 'IS',
  ISR: 'IL',
  ITA: 'IT',
  JAM: 'JM',
  JEY: 'JE',
  JOR: 'JO',
  JPN: 'JP',
  KAZ: 'KZ',
  KEN: 'KE',
  KGZ: 'KG',
  KHM: 'KH',
  KIR: 'KI',
  KNA: 'KN',
  KOR: 'KR',
  KWT: 'KW',
  LAO: 'LA',
  LBN: 'LB',
  LBR: 'LR',
  LBY: 'LY',
  LCA: 'LC',
  LIE: 'LI',
  LKA: 'LK',
  LSO: 'LS',
  LTU: 'LT',
  LUX: 'LU',
  LVA: 'LV',
  MAC: 'MO',
  MAF: 'MF',
  MAR: 'MA',
  MCO: 'MC',
  MDA: 'MD',
  MDG: 'MG',
  MDV: 'MV',
  MEX: 'MX',
  MHL: 'MH',
  MKD: 'MK',
  MLI: 'ML',
  MLT: 'MT',
  MMR: 'MM',
  MNE: 'ME',
  MNG: 'MN',
  MNP: 'MP',
  MOZ: 'MZ',
  MRT: 'MR',
  MSR: 'MS',
  MTQ: 'MQ',
  MUS: 'MU',
  MWI: 'MW',
  MYS: 'MY',
  MYT: 'YT',
  NAM: 'NA',
  NCL: 'NC',
  NER: 'NE',
  NFK: 'NF',
  NGA: 'NG',
  NIC: 'NI',
  NIU: 'NU',
  NLD: 'NL',
  NOR: 'NO',
  NPL: 'NP',
  NRU: 'NR',
  NZL: 'NZ',
  OMN: 'OM',
  PAK: 'PK',
  PAN: 'PA',
  PCN: 'PN',
  PER: 'PE',
  PHL: 'PH',
  PLW: 'PW',
  PNG: 'PG',
  POL: 'PL',
  PRI: 'PR',
  PRK: 'KP',
  PRT: 'PT',
  PRY: 'PY',
  PSE: 'PS',
  PYF: 'PF',
  QAT: 'QA',
  REU: 'RE',
  ROU: 'RO',
  RUS: 'RU',
  RWA: 'RW',
  SAU: 'SA',
  SDN: 'SD',
  SEN: 'SN',
  SGP: 'SG',
  SGS: 'GS',
  SHN: 'SH',
  SJM: 'SJ',
  SLB: 'SB',
  SLE: 'SL',
  SLV: 'SV',
  SMR: 'SM',
  SOM: 'SO',
  SPM: 'PM',
  SRB: 'RS',
  SSD: 'SS',
  STP: 'ST',
  SUR: 'SR',
  SVK: 'SK',
  SVN: 'SI',
  SWE: 'SE',
  SWZ: 'SZ',
  SXM: 'SX',
  SYC: 'SC',
  SYR: 'SY',
  TCA: 'TC',
  TCD: 'TD',
  TGO: 'TG',
  THA: 'TH',
  TJK: 'TJ',
  TKL: 'TK',
  TKM: 'TM',
  TLS: 'TL',
  TON: 'TO',
  TTO: 'TT',
  TUN: 'TN',
  TUR: 'TR',
  TUV: 'TV',
  TWN: 'TW',
  TZA: 'TZ',
  UGA: 'UG',
  UKR: 'UA',
  UMI: 'UM',
  UNK: 'XK',
  URY: 'UY',
  USA: 'US',
  UZB: 'UZ',
  VAT: 'VA',
  VCT: 'VC',
  VEN: 'VE',
  VGB: 'VG',
  VIR: 'VI',
  VNM: 'VN',
  VUT: 'VU',
  WLF: 'WF',
  WSM: 'WS',
  YEM: 'YE',
  ZAF: 'ZA',
  ZMB: 'ZM',
  ZWE: 'ZW',
};

const COUNTRY_CODE_ALIASES = {
  UK: 'GB',
};
Object.assign(COUNTRY_CODE_ALIASES, ALPHA3_TO_ALPHA2);

const normalizeCountryName = (value) => {
  if (!value || typeof value !== "string") return "";
  return value.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
};

const resolveAlpha2Capital = (code) => {
  if (!code || code.length !== 2) return null;
  return COUNTRY_CAPITALS[code]?.capital || null;
};

export const getCountryCapital = (countryOrCode) => {
  if (!countryOrCode || typeof countryOrCode !== "string") return null;
  const trimmed = countryOrCode.trim();
  if (!trimmed) return null;
  const upper = trimmed.toUpperCase();

  if (upper.length === 3) {
    const mapped = ALPHA3_TO_ALPHA2[upper];
    if (mapped) {
      const capital = resolveAlpha2Capital(mapped);
      if (capital) return capital;
    }
  }

  const canonicalCode = COUNTRY_CODE_ALIASES[upper] || upper;
  const directCapital = resolveAlpha2Capital(canonicalCode);
  if (directCapital) return directCapital;

  const normalized = normalizeCountryName(trimmed);
  for (const entry of Object.values(COUNTRY_CAPITALS)) {
    if (entry.name && normalizeCountryName(entry.name) === normalized) return entry.capital || null;
    if (Array.isArray(entry.altNames)) {
      for (const alt of entry.altNames) {
        if (normalizeCountryName(alt) === normalized) return entry.capital || null;
      }
    }
  }
  return null;
};

export const getCountryMetadata = (countryOrCode) => {
  if (!countryOrCode || typeof countryOrCode !== "string") return null;
  const trimmed = countryOrCode.trim();
  if (!trimmed) return null;
  const upper = trimmed.toUpperCase();

  if (upper.length === 3 && ALPHA3_TO_ALPHA2[upper]) {
    const mapped = ALPHA3_TO_ALPHA2[upper];
    return mapped ? { alpha2: mapped, ...COUNTRY_CAPITALS[mapped] } : null;
  }

  const canonicalCode = COUNTRY_CODE_ALIASES[upper] || upper;
  if (COUNTRY_CAPITALS[canonicalCode]) {
    return { alpha2: canonicalCode, ...COUNTRY_CAPITALS[canonicalCode] };
  }

  const normalized = normalizeCountryName(trimmed);
  for (const [code, entry] of Object.entries(COUNTRY_CAPITALS)) {
    if (entry.name && normalizeCountryName(entry.name) === normalized) return { alpha2: code, ...entry };
    if (Array.isArray(entry.altNames)) {
      for (const alt of entry.altNames) {
        if (normalizeCountryName(alt) === normalized) return { alpha2: code, ...entry };
      }
    }
  }
  return null;
};

export default COUNTRY_CAPITALS;
